import { module as BaseModule } from 'modujs';
import Gsap from 'gsap';
import { spline } from '@georgedoescode/generative-utils';

export default class extends BaseModule {
  constructor(m) {
    super(m);
  }

  init() {
    const scene = this.el.querySelector('svg');
    const liquidCircle = scene.querySelector('#liquid-circle');

    const [vbX, vbY, vbWidth, vbHeight] = scene.getAttribute('viewBox').split(' ').map(Number);

    const detail = 40;
    const radius = Math.min(vbWidth, vbHeight) * 0.35;
    const center = { x: vbWidth / 2, y: vbHeight / 2 };

    const points = [];
    for (let i = 0; i < detail; i++) {
      const angle = (Math.PI * 2 * i) / detail;
      points.push({
        x: center.x + Math.cos(angle) * radius,
        y: center.y + Math.sin(angle) * radius,
        angle
      });
    }

    Gsap.ticker.add(() => {
      const time = Date.now() * 0.002;
      points.forEach(p => {
        const r = radius + Math.sin(time + p.angle * 8) * 8;
        p.x = center.x + Math.cos(p.angle) * r;
        p.y = center.y + Math.sin(p.angle) * r;
      });

      liquidCircle.setAttribute('d', spline(points, 1, true));
    });
  }
}
